import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Get Admin Profile
export const getAdminProfileAPI = async () => {
  const response = await apiService.get(endpoints.getAdminProfile);
  return response.data;
};

// ✅ Update Admin Profile
export const updateAdminProfileAPI = async (data) => {
  const response = await apiService.put(endpoints.updateAdminProfile, data);
  return response.data;
};

// ✅ Upload Profile Image
export const uploadProfileImageAPI = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiService.post(endpoints.uploadProfileImage, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// ✅ Delete Profile Image
export const deleteProfileImageAPI = async () => {
  const response = await apiService.delete(endpoints.deleteProfileImage);
  return response.data;
};

// ✅ Change Password
export const changePasswordAPI = async (data) => {
  const response = await apiService.put(endpoints.changePassword, data);
  return response.data;
};

// ==========================================
// ✅ NEW: Company Logo APIs (Based on Swagger)
// ==========================================

// Upload Company Logo
export const uploadCompanyLogoAPI = async (file) => {
  const formData = new FormData();
  formData.append("file", file); // Parameter name is 'file' as per your swagger image
  const response = await apiService.post("/settings/company-logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// Delete Company Logo
export const deleteCompanyLogoAPI = async () => {
  const response = await apiService.delete("/settings/company-logo");
  return response.data;
};